"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  background-color: ", ";\n  color: ", ";\n  font-size: 16px;\n  font-family: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.table = void 0;

var _core = require("@emotion/core");

var table = function table(_ref) {
  var theme = _ref.theme,
      fullWidth = _ref.fullWidth;
  return (0, _core.css)(_templateObject(), fullWidth ? '100%' : 'auto', theme.bColorneutal00, theme.bColorneutral07, theme.bTextsupportFontFamily);
};

exports.table = table;